<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入" v-model="queryParams.codeName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['system:sysCodeRuleConfig:add']" >新增</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" v-hasPermi="['system:sysCodeRuleConfig:remove']" :disabled="selectedRowKeys.length === 0">删除</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.CODE_CONFIG_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="action" slot-scope="{ record }">
            <a @click="$refs.createModal.show(record)" v-hasPermi="['system:sysCodeRuleConfig:edit']">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="handleGen(record)" v-hasPermi="['system:sysCodeRuleConfig:currentString']">生成</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="handleDelete(record)" v-hasPermi="['system:sysCodeRuleConfig:remove']">删除</a>
          </span>
          <span slot="status" slot-scope="{ record }">
            {{ statusFormat(record) }}
          </span>
          <span slot="copy" slot-scope="{ text, record }">
            <a @click="Clone(text, record)">
              <a-icon type="copy" />
            </a>
            {{ text }}
          </span>
          <span slot="code" slot-scope="{ record }">
            <a @click="Clone(record.codePrefix + ' ${' + record.codeYear + record.codeMonth + record.codeDay + record.codeHour + record.codeMinute + record.codeSecond + record.codeMillisecond + '} ' + '${' + record.numCount + '}', record)">
              <a-icon type="copy" />
            </a>
            {{ record.codePrefix + ' ${' + record.codeYear + record.codeMonth + record.codeDay + record.codeHour + record.codeMinute + record.codeSecond + record.codeMillisecond + '} ' + '${' + record.numCount + '}' }}
          </span>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- 创建/编辑编码,单独封装了组件 -->
        <create-form
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { delType, genType, listType } from '@/api/system/codeconfig'
import CreateForm from './components/CreateForm'
import { copy } from "@/api/system/rmsmqlog";
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'Codeconfig',
  components: {
    CreateForm
  },
  data () {
    return {
             // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listType, true),
        pageCurrent: true
      },
       // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        codeName: undefined
      },
      // 状态编码
      statusOptions: [],
      // 编码表格数据
      typeList: [],
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '名称',
          dataIndex: 'codeName',
          width: 250,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '前缀',
        //   dataIndex: 'codePrefix',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '年',
        //   dataIndex: 'codeYear',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeYear' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '月',
        //   dataIndex: 'codeMonth',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeMonth' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '日',
        //   dataIndex: 'codeDay',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeDay' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '时',
        //   dataIndex: 'codeHour',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeHour' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '分',
        //   dataIndex: 'codeMinute',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeMinute' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '秒',
        //   dataIndex: 'codeSecond',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeSecond' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '毫秒',
        //   dataIndex: 'codeMillisecond',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'codeMillisecond' },
        //   customRender: (text, row, index) => {
        //     if (text === null || text === '') {
        //       return '否'
        //     }
        //     return '是'
        //   },
        //   align: 'center'
        // },
        // {
        //   title: '流水号长度',
        //   dataIndex: 'numCount',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '编码表达式',
          dataIndex: 'codeYear',
          scopedSlots: { customRender: 'code' },
          align: 'left'
        },
        {
          title: '当前编码',
          dataIndex: 'currentString',
          scopedSlots: { customRender: 'copy' },
          align: 'left'
        },
        {
          title: '操作',
          width: 300,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      CODECONFIG_LIST: []
    }
  },
  created () {
    // this.getList()
    this.getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data
    })
    this.getCodeConfigList()
  },
  mounted () {
    this.onSearch();
  },
  methods: {
      /** 行选中 */
     selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      },
        // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    Clone (text) {
      copy(text).then((res) => {
        // 这里是调用ant的提示框，可以根据自己的需求看写什么
        this.$message.success(res)
      })
    },
    getCodeConfigList () {
      const params = {
        pageNum: 1,
        pageSize: 10
      }
      listType(params).then(res => {
        if (res.code === 200 && res.rows && res.rows.length > 0) {
          const arr = res.rows;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.id,
              value: element.codeName
            }
            list.push(obj)
          });
          this.CODECONFIG_LIST = list;
        }
      })
    },
    /** 查询编码类型列表 */
    getList () {
      this.tableLoading = true
      listType(this.queryParams).then(response => {
          this.typeList = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 编码状态编码翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        codeName: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleGen (row) {
      const id = row.id
      const self = this
      const genParams = {
        id: id
      }
      genType(genParams).then(response => {
        if (response.code === 200) {
          self.$message.success('生成成功!')
          self.onSearch()
        } else {
          self.$message.error(response.msg)
        }
      })
    },
    /** 生成按钮操作 */
    handleDelete (row) {
      const id = row.id
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 编码编号为${id}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delType(id).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 编码编号为${ids}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delType(ids).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    }
  }
}
</script>
